import { PermissionNode, FlatPermission } from '../interface/permissions';

export function normalizePermissionTree(
  nodes: PermissionNode[],
  parentKey: string | null = null,
  depth = 0,
  acc: Map<string, FlatPermission> = new Map()
): Map<string, FlatPermission> {
    if (!Array.isArray(nodes)) {
        return acc;
    }
    for (const node of nodes) {
        acc.set(node.key, {
            key: node.key,
            label: node.label,
            type: node.type,
            enabled: node.enabled,
            parentKey,
            depth,
            actions: node.permissions ?? {},
        });

        if (node.children?.length) {
            normalizePermissionTree(node.children, node.key, depth + 1, acc);
        }
    }
    return acc;
}